import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Constants from '../constants';
import { Themes } from '../models';

interface IThemeState {
	isLoading: boolean;
	themes: Themes;
}

const initialState: IThemeState = {
	isLoading: true,
	themes: {},
};

const loadThemes = createAsyncThunk('themes/loadThemes', async () => {
	const response = await axios.get<Themes>(Constants.THEMES_API_URL);
	return response.data;
});

const themeSlice = createSlice({
	name: 'themes',
	initialState,
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(loadThemes.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(loadThemes.fulfilled, (state, action) => {
				state.isLoading = false;
				state.themes = action.payload;
			})
			.addCase(loadThemes.rejected, (state) => {
				state.isLoading = false;
			}),
});

export { type IThemeState, initialState, loadThemes };
export default themeSlice.reducer;
